import { render, staticRenderFns } from "./WinesList.vue?vue&type=template&id=5817a1ce"
import script from "./WinesList.vue?vue&type=script&lang=js"
export * from "./WinesList.vue?vue&type=script&lang=js"
import style0 from "./WinesList.vue?vue&type=style&index=0&id=5817a1ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports